import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';


@Component({
  selector: 'app-statconnection',
  templateUrl: './statconnection.component.html',
  styleUrls: ['./statconnection.component.css']
})
export class StatconnectionComponent implements OnInit {
  cohorte: any = null;
  breadcrumbItems!: BreadcrumbItem[];

  constructor(
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.cohorte = this.route.snapshot.params['cohortId'];
    this.breadcrumbItems = [
      { label: 'SIGUI' },
      {
        label: `SESSION ${this.cohorte}`,
        url: `/dashboard/appels/candidatures/${this.cohorte}`,
      },
      {
        label: "STATISTIQUES DE CONNECTION",
        url: `/dashboard/appels/statconnection/${this.cohorte}`,
      },
    ];
  }


}
